/* eslint-disable react/prop-types */
import classes from './index.module.css';

export const Panel = ({
  icon, title, children, className = '', footer,
}) => (
  <div className={`${classes.panel} ${className}`}>
    <section className={classes.panel_content}>
      {title ? (
        <div className={classes.header}>
          {!icon ? null : <img src={icon} alt="" className={classes.icon} />}
          <div className={classes.title}>{title}</div>
        </div>
      ) : null}
      {children}
    </section>
    {footer ? <footer className={classes.panel_footer}>{footer}</footer> : null}
  </div>
);
